// The frame of the signed-out pages (sign-in, forgot and reset password):
// the app's title above a card, from Refine's shadcn/ui registry
// `sign-in-form`.

import type { ReactNode } from 'react'

import { useRefineOptions } from '@refinedev/core'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '~/components/ui/card'
import { Separator } from '~/components/ui/separator'
import { cn } from '~/lib/utils'

export const AuthCard = ({
  title,
  description,
  children,
}: {
  title: string
  description: ReactNode
  children: ReactNode
}) => {
  const { title: appTitle } = useRefineOptions()

  return (
    <div
      className={cn(
        'flex',
        'flex-col',
        'items-center',
        'justify-center',
        'px-6',
        'py-8',
        'min-h-svh',
      )}
    >
      <div className={cn('flex', 'items-center', 'justify-center', 'gap-3')}>
        <div className={cn('text-foreground', '[&>svg]:w-12', '[&>svg]:h-12')}>
          {appTitle.icon}
        </div>
        <span className={cn('text-2xl', 'font-semibold')}>{appTitle.text}</span>
      </div>

      <Card className={cn('sm:w-[456px]', 'p-12', 'mt-6')}>
        <CardHeader className={cn('px-0')}>
          <CardTitle
            className={cn(
              'text-blue-600',
              'dark:text-blue-400',
              'text-3xl',
              'font-semibold',
            )}
          >
            {title}
          </CardTitle>
          <CardDescription
            className={cn('text-muted-foreground', 'font-medium')}
          >
            {description}
          </CardDescription>
        </CardHeader>

        <Separator />

        <CardContent className={cn('px-0')}>{children}</CardContent>
      </Card>
    </div>
  )
}

AuthCard.displayName = 'AuthCard'
